import { setEmbedToken } from "../../actions/actionCreators.js";
import { store } from "../../store.js";

export const getStartTime = () => Date.now()
export const getDeltaTime = startTime =>  Date.now() - startTime
export const lerp = ( v0, v1, t ) => ( 1 - t ) * v0 + t * v1
export const mobileTest = () => {
    let userAgent = navigator.userAgent || navigator.vendor || window.opera
    // Windows Phone must come first because its UA also contains "Android"
    // can later be reworked to detect which mobile OS
    if (/windows phone/i.test(userAgent)) {
        return true;
    }
    if (/android/i.test(userAgent)) {
        return true;
    }
    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return true;
    }
    return false;
};

export const startFullStorySession = () => {
    // start recording
    window['_fs_debug'] = false;
    window['_fs_host'] = 'fullstory.com';
    window['_fs_org'] = 'testdrive';
    window['_fs_namespace'] = 'FS' + (Math.random() * 100000);
    window["_fs_replay_flags"] = "forceSession,getEmbed,anonymize";

    ( function( m, n, e, t, l, o, g, y ){
        if (e in m) {if(m.console && m.console.log) { m.console.log('FullStory namespace conflict. Please set window["_fs_namespace"].'); } return; }
        g=m[e]=function(a,b){g.q?g.q.push([a,b]):g._api(a,b);};g.q=[];
        o=n.createElement(t);o.async=1;o.src='https://'+(window._fs_host)+'/s/fs.js';
        y=n.getElementsByTagName(t)[0];y.parentNode.insertBefore(o,y);
        g.identify=function(i,v){g(l,{uid:i});if(v)g(l,v)};g.setUserVars=function(v){g(l,v)};
        y="rec";g.shutdown=function(i,v){g(y,!1)};g.restart=function(i,v){g(y,!0)};
        g.identifyAccount=function(i,v){o='account';v=v||{};v.acctId=i;g(o,v)};
        g.clearUserCookie=function(){};
    })( window, document, window[ '_fs_namespace' ],'script','user');
};

export const stopFullStorySession = () => store.dispatch( setEmbedToken() )
export const maxSceneWidth = () => {
    const max = document.getElementById( "root" ).offsetHeight * 1.333334
    return { "maxWidth" : max + "px"};
}


// WEBPACK FOOTER //
// ./src/components/utils/helpers.js